import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import {mbeConfigService} from './mbe-config.service';
import {FinancialInstruction, FinDataGridAPI} from '../..';
import { normalizeFinancialInstructionForApi } from '../util/fin-request-payload.util';
import { BasicResponse, SortFilterInterface } from '@auth-suite-services/services';

@Injectable({
  providedIn: 'root',
})
export class FinancialService {
  private URL;
  headers: HttpHeaders; 

  constructor(
    // See C001 - 2026-09-07 - HE
    // @Inject(mbeConfigService) private config,
    @Inject(mbeConfigService) private config: any,
    private httpClient: HttpClient
  ) {
    this.URL =
      config.REST_SERVER_HOST +
      // See C001 - 2026-09-07 - HE
      // config.REST_SERVER_url.find((restUrl) => restUrl.api === 'MBE').url;
      config.REST_SERVER_url.find((restUrl: { api?: string; url?: string }) => restUrl.api === 'MBE').url;
    this.headers = new HttpHeaders().set('Content-Type', 'application/json');
  }
  

  getAllFinancialIns(
    pageIndex: number,
    pageSize: number,
    sortActive: string,
    sort: string,
    sortFilter?: SortFilterInterface
  ): Observable<FinDataGridAPI> {
    console.log('PageIndex; PageSize; SortActive; Sort');
    console.log(pageIndex, pageSize, sortActive, sort);
    const headers = this.headers;
    // PK 09/02/2026 - Send empty object when payload is empty/0 so backend gets {} not number (avoids parsing error)
    // return this.httpClient.post<FinDataGridAPI>(
    //   `${this.URL}/fin/allfinancialins/${pageIndex}/${pageSize}/${
    //     sortActive ? sortActive : 'id'
    //   }/${sort ? sort : 'asc'}`,sortFilter,
    //   { headers }
    // );
    const body =
      sortFilter && typeof sortFilter === 'object' && !Array.isArray(sortFilter)
        ? sortFilter
        : {};
    // tslint:disable-next-line:max-line-length
    return this.httpClient.post<FinDataGridAPI>(
      `${this.URL}/fin/allfinancialins/${pageIndex}/${pageSize}/${
        sortActive ? sortActive : 'id'
      }/${sort ? sort : 'asc'}`,
      body,
      { headers }
    );
  }

  updateFin(fin: FinancialInstruction): Observable<BasicResponse> {
    const headers = this.headers;
    // Safety net: coerce form values to FINRequest types before POST. 05/08/2026 PK.
    const body = normalizeFinancialInstructionForApi(
      fin as unknown as Record<string, unknown>
    );
    console.log('Update Fin: ' + JSON.stringify(body));
    return this.httpClient.post<BasicResponse>(
      `${this.URL}/fin/updatefinancialins`,
      body,
      { headers }
    );
  }

  createFIN(fin: FinancialInstruction): Observable<BasicResponse> {
    const headers = this.headers;
    // Safety net: coerce form values to FINRequest types before POST. 05/08/2026 PK.
    const body = normalizeFinancialInstructionForApi(
      fin as unknown as Record<string, unknown>
    );
    console.log('Create Fin: ' + JSON.stringify(body));
    return this.httpClient.post<BasicResponse>(
      `${this.URL}/fin/createfinancialins`,
      body,
      { headers }
    );
  }

  getFinIns(id: number) {
    console.log('ID');
    console.log(id);
    const headers = this.headers;
    return this.httpClient.get<FinancialInstruction>(
      `${this.URL}/fin/getfinancialins/${id}`,
      { headers }
    );
  }

  // Added getFinNo for FIN wizard next InstructionNo autofill. 04/06/2026 PK.
  getFinNo(): Observable<{ instructionNo: number }> {
    const headers = this.headers;
    return this.httpClient.get<{ instructionNo: number }>(
      `${this.URL}/fin/getfinno`,
      { headers }
    );
  }
}

// ========================================
// CHANGE LOG
// ========================================
// C001: Typed FinancialService constructor config as any and REST_SERVER_url.find restUrl as { api?: string; url?: string }. Previous behavior: constructor parameters were untyped (implicit any), which failed Jest/ts-jest under noImplicitAny when financial.service.spec.ts imported the service for AM ISSUE A HTTP tests. New behavior: config and restUrl have explicit types so the spec compiles. Reason: Enable AM ISSUE A unit tests that POST RecordDate/RecordTime filters to /fin/allfinancialins. Context: Same InjectionToken pattern as DocumentationListService. Impact: Runtime URL construction unchanged. - 2026-09-07 - HE
